import { inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, catchError, switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { TaskLogService } from '../../services/task-log.service'
import { activityLogActions } from './task-log.actions'

export const loadTaskLogs$ = createEffect(
  (actions$ = inject(Actions), tasklogService = inject(TaskLogService)) =>
    actions$.pipe(
      ofType(activityLogActions.loadMyLogs),
      switchMap(action =>
        tasklogService.getMyTaskLogs(action.userId, action.page, action.limit).pipe(
          map(res => {
            return activityLogActions.loadMyLogsSuccess({
              totalCount: res.totalCount,
              tasklogs: res.logs
            })
          }),
          catchError(error => of(activityLogActions.loadMyLogsFailure({ error: error.message })))
        )
      )
    ),
  { functional: true }
)

export const loadBusinessTaskLogs$ = createEffect(
  (actions$ = inject(Actions), tasklogService = inject(TaskLogService)) =>
    actions$.pipe(
      ofType(activityLogActions.loadBusinessLogs),
      switchMap(action =>
        tasklogService
          .getBusinessTaskLogs(action.businessId, action.page, action.limit, action.filters)
          .pipe(
            map(res => {
              return activityLogActions.loadBusinessLogsSuccess({
                totalBusinessLogCount: res.totalCount,
                businessTasklogs: res.logs
              })
            }),
            catchError(error =>
              of(activityLogActions.loadBusinessLogsFailure({ error: error.message }))
            )
          )
      )
    ),
  { functional: true }
)

export const taskLogsEffects = {
  loadTaskLogs$,
  loadBusinessTaskLogs$
}
